import { Fetch } from '../../services/NetworkService';
import { MomError } from './MomError';
import { combineAsyncCalls } from './combineAsyncCalls';

export const HEWEB_LOGIN_URL = '/members/login';

const SUCCESS = 200;

const getAuthLocation = (response: Response) => {
  const authLocation = response.headers.get('auth-location');
  if (response.status !== SUCCESS || !authLocation) throw new MomError(response);
  return authLocation;
};

const refreshLoginInternal = async (fetch: Fetch) => {
  // Hit the Heweb login endpoint to get a Mom authorization URL with its state parameter set up
  const loginUrlResponse = await fetch(HEWEB_LOGIN_URL, {
    credentials: 'same-origin',
    headers: {
      accept: 'application/json, application/x-auth-location',
    },
  });

  const momAuthorizeUrl = getAuthLocation(loginUrlResponse);

  // Hit the Mom authorization endpoint to get an Heweb URL containing an access code

  const momAuthorizeResponse = await fetch(momAuthorizeUrl, {
    credentials: 'include',
    mode: 'cors',
    headers: {
      accept: 'application/json, application/x-auth-location',
    },
  });

  const codeSetUrl = getAuthLocation(momAuthorizeResponse);

  // Hit the Heweb access code URL. This will set our HttpOnly cookies as a side-effect, leaving us with a valid session.

  const codeSetResponse = await fetch(codeSetUrl, {
    credentials: 'same-origin',
    headers: {
      accept: 'application/json',
    },
  });

  if (codeSetResponse.status !== SUCCESS) throw new MomError(codeSetResponse);
};

// Wrap the login routine to ensure any simultaneous calls get combined together, ensuring
// That we will only be talking to mom with a single transaction at a time.
export const refreshLogin = combineAsyncCalls(refreshLoginInternal);
